/* Eliorane - animations d'apparition des pages secondaires (assets/lc-page-anim.js)
   Pose data-lc-anim="on" sur l'élément observé quand il entre à l'écran (zoom-fade, 1 s). */
(function () {
  if (window.lcPageAnim) return;
  window.lcPageAnim = true;
  var els = document.querySelectorAll('[data-lc-anim]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.setAttribute('data-lc-anim', 'on'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.setAttribute('data-lc-anim', 'on');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { io.observe(el); });
})();
